import axios from 'axios';
import { getToken } from '../../../utils/auth';

const DOWNLOAD_REPORT_API_URL = '/export-data';

export const getReport = async (selections, dataType, reportFormat) =>
  await axios.get(DOWNLOAD_REPORT_API_URL, {
    responseType: 'blob',
    baseURL: process.env.API_BASE_URL,
    params: { ...selections, dataType, reportFormat },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
